import { render, staticRenderFns } from "./ItemTypeChips.vue?vue&type=template&id=73e40ef8&scoped=true"
import script from "./ItemTypeChips.vue?vue&type=script&lang=js"
export * from "./ItemTypeChips.vue?vue&type=script&lang=js"
import style0 from "./ItemTypeChips.vue?vue&type=style&index=0&id=73e40ef8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73e40ef8",
  null
  
)

export default component.exports